import { render, staticRenderFns } from "./ReportUser.htm?vue&type=template&id=65ffe856&scoped=true&"
import script from "./ReportUser.ts?vue&type=script&lang=js&"
export * from "./ReportUser.ts?vue&type=script&lang=js&"
import style0 from "./ReportUser.scss?vue&type=style&index=0&id=65ffe856&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ffe856",
  null
  
)

export default component.exports